import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../Translations';
import Store from '../Store';
import { ExperienceResource, ExperiencesResource } from '../Types';
import ArrowLeftIcon from './ArrowLeftIcon';

interface Props {
  experiences: ExperiencesResource;
  store: Store;
  resource: ExperienceResource;
}

const Subheading: React.FC<Props> = ({ experiences, store, resource }) => (
  <div className="flex items-center">
    <div className="w-[20px] h-[20px] cursor-pointer" onClick={() => store.loaded(experiences)}>
      <ArrowLeftIcon />
    </div>
    <div className="font-semibold text-xl pl-4">
      <T kind='Adding "{{name}}"' name={resource.payload.title.text} />
    </div>
  </div>
);

export default observer(Subheading);
